import { render, staticRenderFns } from "./Kickstarter.vue?vue&type=template&id=4e33388b&"
import script from "./Kickstarter.vue?vue&type=script&lang=js&"
export * from "./Kickstarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports